export interface MemberPlan {
  id: string;
  name: string;
  period: string;
  price: string;
  originalPrice: string;
  tag?: string;
  badge?: string;
  highlight?: boolean;
  features: string[];
}

export const memberPlans: MemberPlan[] = [
  {
    id: "m1",
    name: "青铜会员",
    period: "月度",
    price: "¥25",
    originalPrice: "¥35",
    features: [
      "畅读海量免费章节",
      "每日免费解锁 1 个 VIP 章节",
      "追漫更新订阅提醒",
      "高清画质阅读",
    ],
  },
  {
    id: "m2",
    name: "白银会员",
    period: "季度",
    price: "¥68",
    originalPrice: "¥95",
    tag: "人气之选",
    highlight: true,
    features: [
      "畅读全部免费章节",
      "每日免费解锁 3 个 VIP 章节",
      "无广告纯净阅读体验",
      "尊享高画质原版资源",
      "新番抢先看优先上线",
    ],
  },
  {
    id: "m3",
    name: "黄金·土豪专属",
    period: "年度",
    price: "¥198",
    originalPrice: "¥320",
    badge: "尊享",
    features: [
      "全部 VIP 章节无限解锁",
      "全程无广告纯净阅读",
      "土豪专属内容抢先看",
      "尊享 4K 高画质原版",
      "专属客服一对一服务",
      "线下/线上粉丝活动资格",
    ],
  },
];

export interface ReviewItem {
  name: string;
  role: string;
  avatar: string;
  stars: number;
  text: string;
}

export const reviews: ReviewItem[] = [
  {
    name: "夜行者",
    role: "三年老读者",
    avatar: "夜",
    stars: 5,
    text: "追了三年韩漫，这家画质是真的高，原版无码高清，比看盗版爽多了。VIP 解锁也方便，当天更新当天就能看到最新章。",
  },
  {
    name: "阿澈",
    role: "黄金会员",
    avatar: "澈",
    stars: 5,
    text: "土豪专属内容是真的抢先看，别的站还要等，这里直接能看。界面干净没广告，阅读体验拉满，贵一点也值。",
  },
  {
    name: "Momo",
    role: "漫画爱好者",
    avatar: "M",
    stars: 5,
    text: "分类特别齐全，都市豪门、逆袭打脸想看什么都有。更新速度也快，追更提醒很贴心，不怕错过更新。",
  },
  {
    name: "北辰",
    role: "白银会员",
    avatar: "北",
    stars: 4,
    text: "无广告这一点我太喜欢了，以前看一话要等半天广告。现在滑到底就直接下一话，沉浸感很强，画质也很清晰。",
  },
  {
    name: "小熊软糖",
    role: "校园恋爱迷",
    avatar: "糖",
    stars: 5,
    text: "被朋友安利来的，本来担心是标题党，结果内容是真好。甜宠恋爱画风细腻，人物也帅，一晚上追完一部完结作。",
  },
  {
    name: "大白",
    role: "忠实追漫党",
    avatar: "白",
    stars: 5,
    text: "每天更新的漫画很多，热门的都在首页能直接看到。VIP 解锁没有套路，明码标价，客服回复也快，体验很省心。",
  },
];